module.exports = __webpack_public_path__ + "media/images/web/home/index/generic-e7b5116caadcea856dd3cd19e3da2225.webp";